module.exports = __webpack_public_path__ + "static/img/target_a3.4c7dc60f.png";